<div class="add-new-payment-method" *ngIf="addablePaymentMethodTypes$ | async as addablePaymentMethodTypes">
  <div *ngFor="let method of addablePaymentMethodTypes; let i = index">
    <yat-add-new-payment-method-button
      [id]="'eb071e48-ed37-4954-851b-9e2c13e9d984-' + i"
      [paymentMethodType]="method"
      [isSelected]="method === selectedWalletPaymentMethodType"
      (clickMethod)="selectPaymentMethod(method)"
      matomoEventClickAction="Submit_AdditionalPaymentMethod">
    </yat-add-new-payment-method-button>
  </div>
</div>
